/**
 * Mirrors packages/component-library/src/theme.ts from actualbudget/actual:
 * a flat map of camelCase token names onto the CSS custom properties declared
 * in src/style/themes/*.css. Kept as `var()` strings so inline styles and
 * canvas-based charts resolve against whichever theme is active.
 */
export const theme = {
  pageBackground: 'var(--color-pageBackground)',
  pageBackgroundModalActive: 'var(--color-pageBackgroundModalActive)',
  pageBackgroundTopLeft: 'var(--color-pageBackgroundTopLeft)',
  pageBackgroundBottomRight: 'var(--color-pageBackgroundBottomRight)',
  pageText: 'var(--color-pageText)',
  pageTextLight: 'var(--color-pageTextLight)',
  pageTextSubdued: 'var(--color-pageTextSubdued)',
  pageTextDark: 'var(--color-pageTextDark)',
  pageTextPositive: 'var(--color-pageTextPositive)',
  pageTextLink: 'var(--color-pageTextLink)',
  pageTextLinkLight: 'var(--color-pageTextLinkLight)',

  numberPositive: 'var(--color-numberPositive)',
  numberNegative: 'var(--color-numberNegative)',
  numberNeutral: 'var(--color-numberNeutral)',
  budgetNumberNegative: 'var(--color-budgetNumberNegative)',
  budgetNumberZero: 'var(--color-budgetNumberZero)',
  budgetNumberNeutral: 'var(--color-budgetNumberNeutral)',
  toBudgetPositive: 'var(--color-toBudgetPositive)',
  toBudgetNegative: 'var(--color-toBudgetNegative)',

  cardBackground: 'var(--color-cardBackground)',
  cardBorder: 'var(--color-cardBorder)',
  cardShadow: 'var(--color-cardShadow)',

  tableBackground: 'var(--color-tableBackground)',
  tableRowBackgroundHover: 'var(--color-tableRowBackgroundHover)',
  tableRowBackgroundHighlight: 'var(--color-tableRowBackgroundHighlight)',
  tableRowBackgroundHighlightText:
    'var(--color-tableRowBackgroundHighlightText)',
  tableRowHeaderBackground: 'var(--color-tableRowHeaderBackground)',
  tableRowHeaderText: 'var(--color-tableRowHeaderText)',
  tableText: 'var(--color-tableText)',
  tableTextLight: 'var(--color-tableTextLight)',
  tableTextSubdued: 'var(--color-tableTextSubdued)',
  tableTextSelected: 'var(--color-tableTextSelected)',
  tableTextInactive: 'var(--color-tableTextInactive)',
  tableHeaderText: 'var(--color-tableHeaderText)',
  tableHeaderBackground: 'var(--color-tableHeaderBackground)',
  tableBorder: 'var(--color-tableBorder)',
  tableBorderSelected: 'var(--color-tableBorderSelected)',
  tableBorderHover: 'var(--color-tableBorderHover)',
  tableBorderSeparator: 'var(--color-tableBorderSeparator)',

  sidebarBackground: 'var(--color-sidebarBackground)',
  sidebarItemBackgroundPending: 'var(--color-sidebarItemBackgroundPending)',
  sidebarItemBackgroundPositive: 'var(--color-sidebarItemBackgroundPositive)',
  sidebarItemBackgroundFailed: 'var(--color-sidebarItemBackgroundFailed)',
  sidebarItemBackgroundHover: 'var(--color-sidebarItemBackgroundHover)',
  sidebarItemBackgroundSelected: 'var(--color-sidebarItemBackgroundSelected)',
  sidebarItemAccentSelected: 'var(--color-sidebarItemAccentSelected)',
  sidebarItemText: 'var(--color-sidebarItemText)',
  sidebarItemTextSelected: 'var(--color-sidebarItemTextSelected)',
  sidebarBudgetName: 'var(--color-sidebarBudgetName)',
  sidebarHeaderText: 'var(--color-sidebarHeaderText)',
  sidebarTextSubdued: 'var(--color-sidebarTextSubdued)',
  sidebarTextMuted: 'var(--color-sidebarTextMuted)',
  sidebarTextPositive: 'var(--color-sidebarTextPositive)',
  sidebarTextFailed: 'var(--color-sidebarTextFailed)',
  sidebarBorder: 'var(--color-sidebarBorder)',
  sidebarControlBackground: 'var(--color-sidebarControlBackground)',
  sidebarBrand: 'var(--color-sidebarBrand)',

  menuBackground: 'var(--color-menuBackground)',
  menuItemBackground: 'var(--color-menuItemBackground)',
  menuItemBackgroundHover: 'var(--color-menuItemBackgroundHover)',
  menuItemText: 'var(--color-menuItemText)',
  menuItemTextSelected: 'var(--color-menuItemTextSelected)',
  menuItemTextHeader: 'var(--color-menuItemTextHeader)',
  menuBorder: 'var(--color-menuBorder)',

  modalBackground: 'var(--color-modalBackground)',
  modalBorder: 'var(--color-modalBorder)',
  overlayBackground: 'var(--color-overlayBackground)',

  mobileHeaderBackground: 'var(--color-mobileHeaderBackground)',
  mobileHeaderText: 'var(--color-mobileHeaderText)',
  mobilePageBackground: 'var(--color-mobilePageBackground)',
  mobileNavBackground: 'var(--color-mobileNavBackground)',
  mobileNavItem: 'var(--color-mobileNavItem)',
  mobileNavItemSelected: 'var(--color-mobileNavItemSelected)',
  mobileViewTheme: 'var(--color-mobileViewTheme)',

  buttonPrimaryText: 'var(--color-buttonPrimaryText)',
  buttonPrimaryBackground: 'var(--color-buttonPrimaryBackground)',
  buttonPrimaryBackgroundHover: 'var(--color-buttonPrimaryBackgroundHover)',
  buttonPrimaryDisabledText: 'var(--color-buttonPrimaryDisabledText)',
  buttonPrimaryDisabledBackground:
    'var(--color-buttonPrimaryDisabledBackground)',
  buttonNormalText: 'var(--color-buttonNormalText)',
  buttonNormalBackground: 'var(--color-buttonNormalBackground)',
  buttonNormalBorder: 'var(--color-buttonNormalBorder)',
  buttonNormalSelectedBackground: 'var(--color-buttonNormalSelectedBackground)',
  buttonNormalDisabledText: 'var(--color-buttonNormalDisabledText)',
  buttonBareText: 'var(--color-buttonBareText)',
  buttonBareBackgroundHover: 'var(--color-buttonBareBackgroundHover)',
  buttonMenuText: 'var(--color-buttonMenuText)',
  buttonMenuBackgroundHover: 'var(--color-buttonMenuBackgroundHover)',
  buttonMenuBorder: 'var(--color-buttonMenuBorder)',

  formLabelText: 'var(--color-formLabelText)',
  formInputBackground: 'var(--color-formInputBackground)',
  formInputBorder: 'var(--color-formInputBorder)',
  formInputBorderSelected: 'var(--color-formInputBorderSelected)',
  formInputText: 'var(--color-formInputText)',
  formInputTextPlaceholder: 'var(--color-formInputTextPlaceholder)',

  pillBackground: 'var(--color-pillBackground)',
  pillBackgroundLight: 'var(--color-pillBackgroundLight)',
  pillText: 'var(--color-pillText)',
  pillTextHighlighted: 'var(--color-pillTextHighlighted)',
  pillTextSubdued: 'var(--color-pillTextSubdued)',
  pillBorder: 'var(--color-pillBorder)',

  noticeBackground: 'var(--color-noticeBackground)',
  noticeText: 'var(--color-noticeText)',
  noticeBorder: 'var(--color-noticeBorder)',
  warningBackground: 'var(--color-warningBackground)',
  warningText: 'var(--color-warningText)',
  warningBorder: 'var(--color-warningBorder)',
  errorBackground: 'var(--color-errorBackground)',
  errorText: 'var(--color-errorText)',
  errorBorder: 'var(--color-errorBorder)',
  upcomingBackground: 'var(--color-upcomingBackground)',
  upcomingText: 'var(--color-upcomingText)',
  upcomingBorder: 'var(--color-upcomingBorder)',

  budgetCurrentMonth: 'var(--color-budgetCurrentMonth)',
  budgetOtherMonth: 'var(--color-budgetOtherMonth)',
  budgetHeaderCurrentMonth: 'var(--color-budgetHeaderCurrentMonth)',
  budgetHeaderOtherMonth: 'var(--color-budgetHeaderOtherMonth)',

  noteTagBackground: 'var(--color-noteTagBackground)',
  noteTagText: 'var(--color-noteTagText)',

  reportsRed: 'var(--color-reportsRed)',
  reportsBlue: 'var(--color-reportsBlue)',
  reportsGreen: 'var(--color-reportsGreen)',
  reportsGray: 'var(--color-reportsGray)',
  reportsLabel: 'var(--color-reportsLabel)',
  reportsInnerLabel: 'var(--color-reportsInnerLabel)',

  chartQual1: 'var(--color-chartQual1)',
  chartQual2: 'var(--color-chartQual2)',
  chartQual3: 'var(--color-chartQual3)',
  chartQual4: 'var(--color-chartQual4)',
  chartQual5: 'var(--color-chartQual5)',
  chartQual6: 'var(--color-chartQual6)',
  chartQual7: 'var(--color-chartQual7)',
  chartQual8: 'var(--color-chartQual8)',
  chartQual9: 'var(--color-chartQual9)',

  calendarBackground: 'var(--color-calendarBackground)',
  calendarText: 'var(--color-calendarText)',
  calendarItemBackground: 'var(--color-calendarItemBackground)',
  calendarItemText: 'var(--color-calendarItemText)',
  calendarSelectedBackground: 'var(--color-calendarSelectedBackground)',

  floatingActionBarBackground: 'var(--color-floatingActionBarBackground)',
  floatingActionBarText: 'var(--color-floatingActionBarText)',

  tooltipBackground: 'var(--color-tooltipBackground)',
  tooltipText: 'var(--color-tooltipText)',
  tooltipBorder: 'var(--color-tooltipBorder)',
} as const;

export type ThemeToken = keyof typeof theme;
